import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { EventCardSliderProps } from "./types";
import {
    EntryOptions,
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";

import { CardSlideShowResponsiveDefault, ResponsiveMapping, SlideshowDefinition } from 'components/cms/definitions';
import { MetaTypeEnum } from 'app/shared';

export class EventCardSliderDefinitions extends CmsReactComponent<EventCardSliderProps> {
    static schemaName = "event-card-slider";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            text: "Başlık",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "settings",
            text: "Ayarlar",
            description: "Slayt Ayarları",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: SlideshowDefinition,
            },
            group: {
                key: "slider",
                title: "Slayt Gösterisi Ayarları",
                withObject: true,
            }
        },
        {
            name: "responsive",
            description: "Cihaz boyutlarındaki değerleri ayarlayın.",
            mapping: ResponsiveMapping,
            default: CardSlideShowResponsiveDefault,
            group: {
                key: "slider",
                title: "Slayt Gösterisi Ayarları",
                withObject: true
            }
        },
        {
            name: "defaultEventType",
            text: "Varsayılan Etkinlik Türü",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "defaultEventPlace",
            text: "Varsayılan Etkinlik Mekanı",
            mapping: {
                type: PropertyMappingType.String
            }
        },
        {
            name: "isShow",
            text: "Liste gösterilsin mi?",
            mapping: {
                type: PropertyMappingType.Boolean
            }
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
        },
        mappingFields: [
            {
                name: "title",
                text: "Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "defaultEventPlace",
                text: "Varsayılan Etkinlik Mekanı",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "defaultEventType",
                text: "Varsayılan Etkinlik Türü",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
        ],
    };
}
